/**
 * 時間前の注文が JEPX 入札番号を持ち、 JEPX の板にある (または板で終わった) と分かっているか
 * (AC-BIN-115、 #10491)。
 *
 * 板への到達は通常は送信軸 (送信済) で分かる。 送信が失敗した札は送信軸からは板に無い扱いに
 * なるが、 取り込みが板で同じ札を見つけて入札番号を紐付けた札は、 送信軸が送信失敗のままでも
 * 板にある。 入札番号は JEPX が受理した札に付く番号で、 その証拠になる。 backend の
 * `IntradayOrder.KnownOnBoardByBidNo` と同じ規則。
 *
 * wire の jepxBidNo には、 紐付けた番号に加えて、 送信済の札に取り込みが見た自分の行の番号
 * (一覧に出すだけの番号、 #12633) も入る。 紐付けた番号だけを読む `KnownOnBoardByBidNo` とは
 * 送信済の札で食い違うが、 この関数を読む判定はその札を送信軸 (送信済) で既に決めているので
 * 結果は変わらない。 例外は、 約定軸が送信失敗のまま送信済になっている旧い行 (今の書き込みは
 * 作らない): GC 前に残っていれば番号が出て、 ステータス列が「送信中」でなく「入札中」になる。
 *
 * 一覧のステータス列 (送信軸のタグを出すかの分岐)・売買逆転の判定母集合・約定率の分母が、
 * 送信失敗の札を板に無いとみなす判定の例外をこれで決める。
 */
export const isKnownOnBoardByBidNo = (order: {
  jepxBidNo?: string | undefined
}): boolean => order.jepxBidNo !== undefined && order.jepxBidNo !== ''
